import { memo, useContext } from "react";

import "./style.css";
import { AppContext } from "../../App";
import { useState } from "react";
import { useEffect } from "react";

import dayjs from "dayjs";

import axios from "axios";

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

import { RegisterForm } from "../form/register/Register";
import { View } from "../view/View";
import { useRef } from "react";

export const Profile = memo(() => {
  const { customers, layoutRightSize } = useContext(AppContext);

  const [register, setRegister] = useState(null);

  const [view, setView] = useState(null);

  const [informationCustomer, setInformationCustomer] = useState(null);

  const faceIds = useRef([]);

  const getInfo = async ({ data }) => {
    const filterFaceIds = data.filter((item) => {
      if (!item.face_id) return false;
      return !faceIds?.current?.includes(item.face_id);
    });

    if (filterFaceIds.length > 0) {
      faceIds.current = Array.from(
        new Set([
          ...(filterFaceIds.map((item) => item.face_id) ?? []),
          ...(faceIds.current ?? []),
        ]),
      );

      try {
        const response = await axios.get(
          `${
            import.meta.env.VITE_API_BOOKING
          }/api/user/detail?faceIds=${filterFaceIds
            ?.map((item) => item.face_id)
            .join(",")}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          },
        );

        if (response?.data?.length > 0) {
          setInformationCustomer((state) => ({
            ...state,
            ...(response?.data ?? []).reduce((sum, cur) => {
              sum[cur.faceId] = cur;
              return sum;
            }, {}),
          }));
        }
      } catch (err) {
        if (err.response.status === 401) {
          toast.error("Hết thời gian đăng nhập vui lòng đăng nhập lại.");
          localStorage.removeItem("accessToken");
          window.location.reload();
          return;
        }
        console.log(err);
        toast.error(err?.response?.data?.error);
      }
    }
  };

  useEffect(() => {
    getInfo({ data: customers });
  }, [customers]);

  return (
    <SimpleBar style={{ height: layoutRightSize.height }}>
      {view ? (
        <View faceId={view.faceId} onBack={() => setView(null)} />
      ) : register ? (
        <RegisterForm
          faceId={register.faceId}
          avatar={
            register.avatar ? `data:image/jpg;base64,${register.avatar}` : null
          }
          onCancel={() => setRegister(null)}
          onOk={({ faceId }) => {
            setRegister(null);
            setView({ faceId });
            faceIds.current = faceIds.current.filter((item) => item !== faceId);
          }}
        />
      ) : (
        <div className="profile">
          {customers?.length > 0 ? (
            (customers ?? []).map((item, index) => (
              <div
                key={index}
                className={`profile-item ${!item.face_id && "disabled"}`}
                onClick={() =>
                  informationCustomer?.[item.face_id]?.fullName
                    ? setView({ faceId: item.face_id })
                    : setRegister({
                        faceId: item.face_id,
                        avatar: item.face_base64,
                      })
                }
              >
                <div className="profile-item-avatar">
                  {item.face_base64 ? (
                    <img src={`data:image/jpg;base64,${item.face_base64}`} />
                  ) : (
                    <svg
                      width="92"
                      height="93"
                      viewBox="0 0 92 93"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_279_2454)">
                        <path
                          d="M46.0001 0.61853C20.7701 0.61853 0.289062 21.1025 0.289062 46.3335C0.289062 71.5645 20.7731 92.0485 46.0001 92.0485C71.2301 92.0485 91.7151 71.5645 91.7151 46.3335C91.7151 21.1025 71.2311 0.61853 46.0001 0.61853ZM46.0001 3.47793C69.6841 3.47793 88.8551 22.6499 88.8551 46.3329C88.8551 70.0159 69.6831 89.1879 46.0001 89.1879C22.3171 89.1879 3.14506 70.0159 3.14506 46.3329C3.14506 22.6499 22.3171 3.47793 46.0001 3.47793ZM46.0001 16.5639C37.1329 16.5639 29.9181 23.8022 29.9181 32.6889C29.9181 41.5756 37.1329 48.8139 46.0001 48.8139C54.8673 48.8139 62.0821 41.5756 62.0821 32.6889C62.0821 23.8022 54.8673 16.5639 46.0001 16.5639ZM46.0001 19.4194C53.3165 19.4194 59.2271 25.3413 59.2271 32.6854C59.2271 40.0295 53.3209 45.9514 46.0001 45.9514C38.6837 45.9514 32.7771 40.0295 32.7771 32.6854C32.7771 25.3413 38.6833 19.4194 46.0001 19.4194ZM46.0001 52.0364C33.6371 52.0364 22.2701 58.8333 16.4181 69.7244C16.0509 70.4158 16.3087 71.2791 17.0001 71.6541C17.6915 72.0252 18.5548 71.7635 18.9298 71.0721C24.2853 61.1033 34.6838 54.8881 45.9998 54.8881C57.3158 54.8881 67.7028 61.1029 73.0588 71.0721C73.2385 71.408 73.5432 71.658 73.9104 71.7674C74.2736 71.8768 74.6643 71.8338 75.0002 71.6541C75.6916 71.2791 75.9494 70.4158 75.5822 69.7244C69.7345 58.8334 58.3631 52.0364 46.0001 52.0364Z"
                          fill="url(#paint0_linear_279_2454)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_279_2454"
                          x1="0.289063"
                          y1="46.3335"
                          x2="91.7151"
                          y2="46.3335"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#639EB3" />
                          <stop offset="1" stop-color="#BE9EAA" />
                        </linearGradient>
                        <clipPath id="clip0_279_2454">
                          <rect
                            width="92"
                            height="92"
                            fill="white"
                            transform="translate(0 0.333374)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </div>
                <div className="profile-item-info">
                  <div className="profile-item-info-item">
                    <span>
                      {item.face_id ? (
                        informationCustomer?.[item.face_id]?.fullName ? (
                          <span>
                            <span style={{ color: "#ff0000" }}>
                              {`[${item.face_id.slice(
                                item.face_id.length - 5,
                              )}] `}
                            </span>
                            <span>
                              {informationCustomer?.[item.face_id]?.fullName}
                            </span>
                          </span>
                        ) : (
                          <span>
                            <span style={{ color: "#ff0000" }}>
                              {`[${item.face_id.slice(
                                item.face_id.length - 5,
                              )}] `}
                            </span>
                            <span>Khách hàng mới</span>
                          </span>
                        )
                      ) : (
                        <span>
                          <span style={{ color: "#ff0000" }}>
                            {`[${item.track_id}] `}
                          </span>
                          <span>Đang định danh ...</span>
                        </span>
                      )}
                    </span>
                  </div>
                  <div className="profile-item-info-item small">
                    <span>Số điện thoại</span>
                    <span>
                      {informationCustomer?.[item.face_id]?.phone ?? "---"}
                    </span>
                  </div>
                  <div className="profile-item-info-item small">
                    <span>Ngày sinh</span>
                    <span>
                      {informationCustomer?.[item.face_id]?.dob
                        ? dayjs(
                            informationCustomer?.[item.face_id]?.dob,
                          ).format("DD/MM/YYYY")
                        : "---"}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: layoutRightSize.height - 36,
              }}
            >
              Không có tìm thấy thông tin khách hàng
            </div>
          )}
        </div>
      )}
    </SimpleBar>
  );
});
